import React from 'react';

import { Cancel as CancelIcon, CheckCircle as CheckIcon } from '@mui/icons-material';
import { StepIcon as BaseStepIcon, Box, StepIconProps } from '@mui/material';

import 'src/theme/palette';

export const StepIcon: React.FC<StepIconProps> = ({ icon: iconLabel, completed, error }) => {
  const icon = React.useMemo(() => {
    if (error) {
      return completed ? (
        <CancelIcon
          data-e2e-element="step-failed"
          sx={theme => ({ color: theme.palette.red?.[600] })}
        />
      ) : (
        <CancelIcon sx={theme => ({ color: theme.palette.grey[400] })} />
      );
    }

    if (completed) {
      return (
        <CheckIcon
          sx={theme => ({ color: theme.palette.primary.main })}
          data-e2e-element="step-success"
        />
      );
    }

    return <BaseStepIcon icon={iconLabel} />;
  }, [iconLabel, completed, error]);

  return <Box display="contents">{icon}</Box>;
};
